import "./styles.css";
import Data from "./Data";

export default function ShowCandidatures() {
  return (
    <div className="data_student">
      <div className="data_container">
        <Data/>
      </div>
    </div>
  );
}
